<div class="all_container" class="flex-column h-100 w-100 bg-gray-50">

    <p-message *ngFor="let msg of msgs" [severity]="getMessageSeverity(msg)" [text]="msg.detail ?? ''"></p-message>
    <div *ngIf="file_downloading" class="p-message p-message-success">
        <div class="p-message-wrapper">
            <span class="p-message-icon pi pi-check"></span>
            <div class="p-message-detail">
                <svg class="animate-spin -ml-1 mr-3 h-5 w-5 text-white inline-block" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                    <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg> &nbsp;Downloading File. Please wait...
            </div>
        </div>
    </div>

    <nav class="flex justify-between py-4 px-6 bg-telus-purple text-white shadow-md">

        <div class="flex items-center w-1/3">

            <img class="inline w-10 rounded-full mx-3 shadow-sm" src="assets/images/logo.png" /><span class="text-xl pr-2 font-semibold">{{site_name}}</span><span class="text-sm text-purple-100 px-2">{{tag_line}}</span>

        </div>

        <div class="w-1/3 flex justify-end items-center">
            <span *ngIf="health_ok" class="text-base">

            <button (click)="deleteConnection()" class="text-sm px-4 py-2 bg-white bg-opacity-10 hover:bg-opacity-20 rounded-lg transition-all duration-200 mr-4"><i
                    class="fas fa-sign-out-alt"
                    ></i>&nbsp;Log out</button>
            </span>
        </div>
    </nav>

    <div *ngIf="page=='settings'" class="w-100 content-center">

        <div class="container-fluid w-2/5 bg-white rounded-2xl mt-8 shadow-lg border border-gray-100">

            <div class="row">
                <div class="col-12">

                    <h5 class="text-telus-purple font-semibold px-3 pt-8 text-xl">Welcome to the web client for {{site_name}}</h5>

                    <form #settingsForm="ngForm" (ngSubmit)="onSubmit()" class="p-3" novalidate>

                        <div class="ui-float-label  py-6">
                            <input [(ngModel)]="username" placeholder="Username"  name="username" pInputText
                                   type="text" value="{{username}}" class="text-base p-6 w-100 rounded-xl bg-gray-200">
                        </div>

                        <div class="ui-float-label py-6">
                            <input [(ngModel)]="password" placeholder="Password"  class="text-lg" name="password" pPassword
                                   type="password" class="text-base p-6 w-100 rounded-xl bg-gray-200">
                            
                        </div>

                        <div class="py-4">
                            <div *ngIf="!isConnectionTested && connError" class="alert alert-danger" role="alert">
                                {{login_error}}
                            </div>
                            <button [disabled]="login_process" class="w-full bg-telus-purple hover:bg-telus-purple-700 text-white font-semibold py-3 px-6 rounded-lg transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed shadow-md" id="connect" label="Connect" type="submit">
                                <svg *ngIf="login_process" class="animate-spin -ml-1 mr-3 h-5 w-5 text-white inline-block" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                    <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                                    <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                  </svg>
                                  Log in</button>

                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>

    <div class="flex p-2 h-full">
        <as-split #split="asSplit" *ngIf="page == 'browse'"  [gutterSize]=3 class="rounded-xl bg-white" unit="percent">
            <as-split-area #area1="asSplitArea" [size]="25">
                <div class="flex px-4 py-3 justify-between border-b border-gray-200 shadow-inner">
                    <div class="flex text-l text-bg-900 font-bold items-center">
                        Folders
                    </div>
                </div>
                <div class="flex justify-start p-3 h-auto w-full">
                    <p-tree (onNodeExpand)="onFolderPathExpand($event)" (onNodeSelect)="onFolderPathSelect($event)" [loading]="loading" [value]="parentNodes" class="h-full w-full truncate overflow-ellipsis" selectionMode="single">
                    </p-tree>
                </div>
            </as-split-area>
            <as-split-area #area2="asSplitArea" [size]="75" class="bg-white">
                <div *ngIf="currentFolderPath != null" class="flex px-4 py-3 h-16 justify-between">
                    <div class="w-4/5 flex justify-start items-center">
                        <p-breadcrumb (onItemClick)="onBreadCrumbClick($event)" [home]="home" [model]="items">
                        </p-breadcrumb>
                    </div>
                </div>
                <div *ngIf="currentFolderPath != null" class="flex px-4 py-0 pb-4 justify-between border-b border-gray-200">
                    <div class="font-bold text-xl w-1/2 pt-2 flex justify-start items-center">
                        <i class="fas fa-folder-open text-yellow-500"></i>&nbsp; <div class="truncate overflow-ellipsis inline-block">{{current_folder?.label}}</div> ({{filesForPath?.length}}&nbsp;files)
                    </div>
                    <div class="flex items-center">
                        <p-dialog [(visible)]="upload_dialog_display" header="Upload File" position="top">
                            <div class="upload-dialog-content">

                                <p-fileUpload #fileUploader
                                              (onUpload)="onUpload($event)"
                                              (uploadHandler)="uploadFile($event,fileUploader)"
                                              [files]="myfiles" [customUpload]="true"
                                              method="post" mode="advanced" name="filename">
                                    <ng-template pTemplate="content">
                                        <div class="upload-drop-area">
                                           <div class="upload-drop-area-text">
                                               Drag a <b>single</b> file within this bordered area to queue for upload
                                               or press "+ Choose" button.
                                               <br/>NOTE: only single file support at the moment.
                                           </div>
                                        </div>
                                    </ng-template>

                                </p-fileUpload>

                            </div>
                            <p-progressBar [ngStyle]="{'visibility':file_uploading==true ? 'visible' : 'hidden'}" mode="indeterminate"></p-progressBar>
                        </p-dialog>
                        <p-dialog [(visible)]="displayFolderDialog" header="Add New Folder" position="top">
                            <div class="new-folder-dialog-content">
                                {{currentFolderPath}} / <input [(ngModel)]="newFolderInputText" class="border-2" type="text" /> /
                                <br><br>
                                <button (click)="newFolderCreate()" [disabled]="newFolderInputText == undefined" class="bg-none border border-red-600 p-2 w-auto h-auto rounded text-gray-800 text-sm mr-2"><i
                                        class="fas fa-folder-plus text-base mr-2 text-yellow-500"></i>Add Folder
                                </button>
                            </div>
                        </p-dialog>

<!--                        <button-->
<!--                                class="bg-none border border-red-600 p-2 w-auto h-auto rounded text-gray-800 text-sm mr-2">-->
<!--                            <i class="fa fa-refresh text-sm text-green-600 mr-2"></i>Refresh-->
<!--                        </button>-->

                        <button (click)="showUploadDialog()"
                                class="bg-telus-purple hover:bg-telus-purple-700 text-white px-4 py-2 rounded-lg text-sm mr-2 transition-all duration-200 shadow-sm">
                            <i class="fa fa-upload text-sm mr-2"></i>Upload
                        </button>

                        <button (click)="deleteFolder()"
                                [disabled]="this.btnDeleteFolderDisabled"
                                class="bg-red-600 hover:bg-red-700 text-white px-4 py-2 rounded-lg text-sm mr-2 transition-all duration-200 shadow-sm disabled:opacity-50 disabled:cursor-not-allowed">
                                    <i class="fas fa-trash text-sm mr-2"></i>Delete Folder
                        </button>
                        <button (click)="displayNewFolderDialog()" class="bg-telus-purple-200 hover:bg-telus-purple-300 text-telus-purple-800 px-4 py-2 rounded-lg text-sm transition-all duration-200 shadow-sm"><i
                                class="fas fa-folder-plus text-base mr-2"></i>Add Sub Folder
                        </button>
                    </div>
                </div>


                <div *ngIf="currentFolderPath != null" class="flex p-3 px-6">
                    <p-table #dt (onEditCancel)="onEditCancel($event)" styleClass="p-datatable-striped" (onEditComplete)="onEditComplete($event)" (onEditInit)="onEditInit($event)" [(selection)]="selectedFile" [globalFilterFields]="['name']" [loading]="loading_table" [paginator]="true" [rowsPerPageOptions]="[5,10,20,30]"
                        [resizableColumns]="true" [rows]="5" [value]="filesForPath" class="h-1/2" selectionMode="single">
                        <ng-template pTemplate="header">
                            <tr>
                                <th pSortableColumn="name" class="w-1/3">File Name
                                    <p-sortIcon field="name"></p-sortIcon>
                                </th>
                                <th pSortableColumn="type">File Type
                                    <p-sortIcon field="type"></p-sortIcon>
                                </th>
                                <th pSortableColumn="size">File Size
                                    <p-sortIcon field="size"></p-sortIcon>
                                </th>

                                <th pSortableColumn="last_modified_on">Last Modified
                                    <p-sortIcon field="last_modified_on"></p-sortIcon>
                                </th>
                                <th class="flex justify-end pr-0">

                                    <div class="border-b-2 p-2 flex bg-white mr-2 justify-center items-center">
                                        <i class="fas fa-search text-gray-500 mr-2"></i>
                                        <input (input)="applyFilterGlobal($event, 'contains')" class="  m-0 border-none text-base" pInputText placeholder="Search" type="text" />
                                    </div>
                                </th>
                            </tr>
                        </ng-template>

                        <ng-template let-file let-rowData pTemplate="body">
                            <tr [pSelectableRow]="rowData" class="f" class="row-data-name">
                                <td [pEditableColumnField]="rowData.name" [pEditableColumn]="rowData">
                                    <p-cellEditor>
                                        <ng-template pTemplate="input">
                                            <input [(ngModel)]="rowData.name" pInputText type="text">
                                        </ng-template>
                                        <ng-template pTemplate="output">
                                            <div pTooltip="{{rowData.name}}" tooltipPosition="top" tooltipEvent="hover" class="text-base truncate overflow-ellipsis border-b-0 border-dotted py-2 border-gray-700"><i class="row-data-edit fas fa-pen text-green-500"></i>
                                                <i class="row-data-icon fas {{getDocIcon(rowData.name)}} text-{{getDocIconColor(rowData.name)}}-700  "></i> &nbsp;{{rowData.name}}
                                            </div>
                                        </ng-template>
                                    </p-cellEditor>
                                </td>
                                <td>{{file.type}}</td>
                                <td><div class="absolute invisible">{{file.size}}</div>{{getFileSize(file.size)}}</td>
                                <td>{{file.last_modified_on | date:'MM/dd/yyyy h:mm a'}}</td>
                                <td class="p-0 text-right">
                                    <button pTooltip="Download File" tooltipPosition="left" tooltipEvent="hover" (click)="selectFileForDownload(rowData)" class="bg-transparent border-none rounded p-2 mr-4"><i
                                            class="fa fa-download text-green-600"></i></button>
                                    <button pTooltip="Delete File" tooltipPosition="left" tooltipEvent="hover" (click)="deleteFile(rowData)" class="bg-transparent border-none rounded p-2"><i class="fa fa-trash text-red-600"></i>
                                    </button>
                                </td>
                            </tr>
                        </ng-template>

                    </p-table>

                </div>
            </as-split-area>
        </as-split>

    </div>
</div>
